
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"80","height":"80","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"width":"80","height":"80","rx":"10","fill":"#EAE3F2"}}),_c('g',{attrs:{"clip-path":"url(#clip0_673_6809)","fill":"#481D72"}},[_c('path',{attrs:{"d":"M43.132 54.923h-6.266a.817.817 0 00-.7.4.8.8 0 000 .8l.55 1.117a3.333 3.333 0 002.95 1.85h.666a3.333 3.333 0 003-1.85l.55-1.117a.8.8 0 00-.318-1.105.816.816 0 00-.432-.095zM40 26.59a1.667 1.667 0 001.667-1.667v-4.166a1.667 1.667 0 00-3.333 0v4.166a1.667 1.667 0 001.667 1.667zM55.318 25.442a1.667 1.667 0 00-2.35 0L50 28.392a1.666 1.666 0 001.183 2.85 1.667 1.667 0 001.167-.484l2.95-2.95a1.669 1.669 0 00.017-2.366zM60 40.757a1.667 1.667 0 00-1.666-1.667h-3.333a1.667 1.667 0 100 3.333h3.333a1.667 1.667 0 001.667-1.666zM30 28.39l-2.966-2.95a1.667 1.667 0 00-2.35 2.35l2.95 2.966c.31.308.73.482 1.167.484a1.666 1.666 0 001.2-2.85zM25 39.09h-3.333a1.666 1.666 0 100 3.333H25a1.666 1.666 0 100-3.333zM40 29.09a10.9 10.9 0 00-10.9 10.9 10.684 10.684 0 004.233 8.583.851.851 0 01.334.667v.75a2.45 2.45 0 002.483 2.433h7.7a2.433 2.433 0 002.433-2.4v-.65a.849.849 0 01.334-.716A10.883 10.883 0 0040 29.09zm4.316 17.1a3.215 3.215 0 00-1.366 2.617.265.265 0 01-.172.266.267.267 0 01-.111.017h-5.334a.282.282 0 01-.283-.283 3.215 3.215 0 00-1.367-2.617 7.567 7.567 0 118.633 0z"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_673_6809"}},[_c('path',{attrs:{"fill":"#fff","transform":"translate(20 19.09)","d":"M0 0h40v40H0z"}})])])])
          )
        }
      }
    